import { Box } from "@mui/material"
import { makeStyles } from "makeStyles"
import Icon from "@mdi/react"
import { mdiChevronRight } from "@mdi/js"
import Link from "../../components/i18n/Link"
import { IntermediateCategoryChildWithProducts } from "../../typings/Category"
import getValueFromLocalizedStringWithFallback from "../../utils/i18n/getValueFromLocalizedStringWithFallback"
import { CountryCode } from "@secureo/common/typings/CountryCode"

const useStyles = makeStyles()({
	gridRow: {
		display: "flex",
		flexFlow: "row wrap",
		justifyContent: "flex-start",
	},
	gridItem: {
		flexBasis: "16.6%",
		width: "250px",
		position: "relative",
		padding: "10px",
		boxSizing: "border-box",
	},
	gridItemWrapper: {
		boxSizing: "initial",
		background: "#F7FAFA",
		border: "1.3px solid #7abfac",
		borderRadius: "5px",
		margin: "0",
		paddingTop: "10px",
		height: "100%",
		width: "100%",
		overflow: "hidden",
		cursor: "pointer",
		textAlign: "center",
		position: "relative",
		verticalAlign: "middle",
		"&:hover": {
			background: "rgba(122, 191, 172, 0.2)",
		},
	},
	icon: {
		color: "#7abfac",
		alignItems: "flex-start",
		height: "40px",
		padding: "15px",
		paddingBottom: "5px",
	},
	title: {
		paddingBottom: "10px",
	},
	"@media only screen and (min-width: 815px) and (max-width: 1300px)": {
		gridItem: {
			flexBasis: "25%",
		},
	},
	"@media only screen and (min-width: 451px) and (max-width: 914.98px)": {
		gridItem: {
			flexBasis: "50%",
		},
	},
	"@media only screen and (max-width: 450px)": {
		gridItem: {
			flexBasis: "100%",
		},
	},
})

const ChildCategoryList = ({ category, slug, locale, countryCode }: Props) => {
	const { classes } = useStyles()

	const { childCategories, nameAllLocales } = category
	const name = getValueFromLocalizedStringWithFallback(nameAllLocales, locale)

	const sortedChildCategories = childCategories
		.sort((a, b) => {
			return a.orderHint - b.orderHint
		})
		.filter((category) => !category.excludedCountryCodes.includes(countryCode))

	return (
		<Box mb={2}>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<Link href={`/c/${slug}`}>
					<h2
						style={{
							marginBottom: "0",
							display: "flex",
							alignItems: "center",
							fontSize: "18px",
						}}
					>
						<Icon path={mdiChevronRight} size={1} />
						<Box component="span">{name}</Box>
					</h2>
				</Link>
			</div>
			<Box mb={4} className={classes.gridRow}>
				{sortedChildCategories.map((subCategory) => {
					const { nameAllLocales, slug, icon } = subCategory
					const name = getValueFromLocalizedStringWithFallback(nameAllLocales, locale)

					return (
						<Box p={3} className={classes.gridItem} key={name}>
							<Link href={`/c/${slug}`}>
								<div className={classes.gridItemWrapper}>
									<img
										src={icon}
										alt={name}
										style={{
											height: "50px",
											width: "50px",
											objectFit: "contain",
										}}
									/>
									<div style={{ fontSize: "15px" }}>{name}</div>
								</div>
							</Link>
						</Box>
					)
				})}
			</Box>
		</Box>
	)
}

interface Props {
	category: IntermediateCategoryChildWithProducts
	slug: string
	locale: string
	countryCode: CountryCode
}

export default ChildCategoryList
